<template>
    <section
        aria-label="Farol do seller"
        class="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700"
    >
        <div
            class="grid grid-cols-1 gap-px bg-gray-200 dark:bg-gray-700 sm:grid-cols-3"
        >
            <template v-if="loading">
                <div
                    v-for="n in 3"
                    :key="n"
                    class="space-y-2 bg-white px-4 py-3 dark:bg-gray-800"
                >
                    <div
                        class="h-2 w-16 rounded-sm bg-gray-100 dark:bg-gray-700"
                    ></div>
                    <div
                        class="h-4 w-40 rounded-sm bg-gray-100 dark:bg-gray-700"
                    ></div>
                    <div
                        class="h-2 w-32 rounded-sm bg-gray-100 dark:bg-gray-700"
                    ></div>
                </div>
            </template>

            <article
                v-else
                v-for="signal in signals"
                :key="signal.key"
                role="button"
                tabindex="0"
                :aria-label="`${signal.question} ${statusLabel(signal.status)}. Ir para a seção ${signal.domain}`"
                class="group cursor-pointer bg-white px-4 py-3 text-left transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500 dark:bg-gray-800 dark:hover:bg-gray-700/60"
                :class="wash(signal.status)"
                @click="$emit('go', signal.key)"
                @keydown.enter.prevent="$emit('go', signal.key)"
                @keydown.space.prevent="$emit('go', signal.key)"
            >
                <div class="flex items-center justify-between gap-2">
                    <p
                        class="font-mono text-[10px] uppercase tracking-[0.16em] text-gray-400 dark:text-gray-500"
                    >
                        {{ signal.domain }}
                    </p>
                    <span
                        class="shrink-0 rounded-full border px-2 py-0.5 font-mono text-[9px] uppercase tracking-[0.1em]"
                        :class="chip(signal.status)"
                    >
                        {{ statusLabel(signal.status) }}
                    </span>
                </div>

                <h3
                    class="mt-1 text-sm font-semibold text-gray-900 dark:text-white"
                >
                    {{ signal.question }}
                </h3>

                <p
                    class="mt-1 line-clamp-2 text-[11px] leading-relaxed text-gray-500 dark:text-gray-400"
                    :title="signal.reason"
                >
                    {{ signal.reason }}
                </p>
            </article>
        </div>
    </section>
</template>

<script>
export default {
    name: "SellerFarol",
    props: {
        // [{ key, domain, question, status: ok|attention|critical, reason }]
        signals: { type: Array, required: true },
        loading: { type: Boolean, default: false },
    },

    emits: ["go"],

    methods: {
        statusLabel(status) {
            return (
                {
                    ok: "ok",
                    attention: "atenção",
                    critical: "alerta",
                }[status] ?? "ok"
            );
        },

        chip(status) {
            return (
                {
                    attention:
                        "border-amber-500/40 bg-amber-500/10 text-amber-600 dark:text-amber-400",
                    critical:
                        "border-rose-500/40 bg-rose-500/10 text-rose-600 dark:text-rose-400",
                }[status] ??
                "border-emerald-500/40 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
            );
        },

        wash(status) {
            return (
                {
                    attention: "!bg-amber-50/70 dark:!bg-amber-500/[0.04]",
                    critical: "!bg-rose-50/70 dark:!bg-rose-500/[0.05]",
                }[status] ?? ""
            );
        },
    },
};
</script>
